document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".js-tab");
  const items = document.querySelectorAll(".js-item");
  const questions = document.querySelectorAll(".js-question");

  tabs.forEach(tab => {
    tab.addEventListener("click", () => {
      const cat = tab.dataset.category;

      tabs.forEach(t => t.classList.remove("active"));
      tab.classList.add("active");

      items.forEach(i => {
        if (i.dataset.category === cat) {
          i.style.display = "block";
        } else {
          i.style.display = "none";
          i.classList.remove("open");
          const answer = i.querySelector('.accordion-help__answer');
          if (answer) {
            answer.style.maxHeight = null;
          }
        }
      });
    });
  });

  questions.forEach(q => {
  q.addEventListener("click", () => {
    const item = q.closest(".js-item");
    const answer = item.querySelector('.accordion-help__answer');
    const icon = q.querySelector('.accordion-help__icon');
    const isOpen = item.classList.toggle("open");

    if (isOpen) {
      answer.style.maxHeight = answer.scrollHeight + "px";
      answer.style.opacity = 1;
      if (icon) icon.textContent = "−"; // ← ここ！
    } else {
      answer.style.maxHeight = null;
      answer.style.opacity = 0;
      if (icon) icon.textContent = "+"; // ← ここ！
    }
  });
});

});
